export const CONSTANTS = {
  FREQUENCY_TYPES: ['YEARLY', 'DAILY', 'WEEKLY', 'MONTHLY'],
  INVALID_SHIFT: 'false-false'
};
